export const Withheld = ({ w }) => <span className="withheld" style={{ width: w }} data-testid="withheld-block" />;
